import React, { Component } from 'react';

class TabTitle extends Component {
    render() {
        let title;
        let option = this.props.title;
        switch (option) {
            case "question":
                title = "";
                return (
                    <div id="questionTableTitle">
                        <h1 id="tabTitle" className="tab-title">{title}</h1>
                    </div>
                );
            case "markscheme":
                title = "Mark Scheme";
                return (
                    <div>
                        <h1 id="tabTitle" className="tab-title">{title}</h1>
                    </div>
                );

            case "examinerreport":
                title = "Examiners Remarks";
                return (
                    <div>
                        <h1 id="tabTitle" className="tab-title">{title}</h1>
                    </div>
                );

            case "notes":
                title = "Notes";
                return (
                    <div>
                        <h1 id="tabTitle" className="tab-title">{title}</h1>
                    </div>
                );

            case "resources":
                title = "Resources";
                return (
                    <div>
                        <h1 id="tabTitle" className="tab-title">{title}</h1>
                    </div>
                );

            default:
                title = "";
                return (
                    <div>
                        <h1 id="tabTitle" className="tab-title">{title}</h1>
                    </div>
                );
        }
    } 
}

export default TabTitle;